import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { Form, Label } from 'semantic-ui-react';
import classnames from 'classnames';
import getObjectProperty from 'lodash/get';
import StyledSelect from './Select.style';

export class SelectComponent extends Component {
  state = { touched: false, selected: '' };

  componentDidUpdate(prevProps) {
    const { field = {}, form = {} } = this.props;

    // when externally updated > if reset, current value should be empty
    const prev = getObjectProperty(
      prevProps.form,
      `values[${field.name | ''}]`
    );
    const current = getObjectProperty(form, `values[${field.name | ''}]`);
    if (prev !== current) {
      this.handleChange({ target: { value: current } }, !!current);
    }
  }

  // for formik touched state issue work around.
  // https://github.com/jaredpalmer/formik/issues/955
  // https://github.com/jaredpalmer/formik/issues/599
  handleChange = (e, touched) => {
    const {
      options,
      onChange,
      field = { name: '', onBlur: () => {}, value: '' },
      form = {}
    } = this.props;

    const { name, onBlur } = field === undefined ? {} : field;
    if (form.setFieldTouched && touched) {
      onBlur(form.setFieldTouched(name, true));
    }
    const selected =
      options.filter(
        option => option.value.toString() === e.target.value.toString()
      ) || [];
    this.setState({ selected: selected[0] && selected[0].text });
    onChange(e);
  };

  renderOptions(options) {
    return options.map((item, idx) => (
      <option key={idx} value={item.value}>
        {item.text}
      </option>
    ));
  }

  render() {
    const {
      field = {}, // only for formik Field
      form = {}, // only for formik Field
      label,
      options,
      placeholder,
      placeholderDisabled = true,
      className,
      disabled = false,
      qa,
      ...rest
    } = this.props;
    const { name } = field;
    const { errors = {}, isValid, touched = {} } = form;
    const { selected } = this.state;

    // formik doesn't like disabled option to select
    const stateClass = `select--${isValid ? 'valid' : 'invalid'}`;
    const selectCSS = classnames('select', touched[name] && stateClass);
    // querySelector does not work with dots(.) - for e2e
    const id = name && name.replace('.', '_');
    return (
      <Form.Field className={className}>
        <label htmlFor={id}>{label}</label>
        <StyledSelect className={selectCSS}>
          <select
            {...rest}
            {...field}
            id={id}
            className="ui selection dropdown"
            onChange={this.handleChange}
            data-qa={qa}
            disabled={disabled}
          >
            {placeholder && (
              <option value="" disabled={placeholderDisabled}>
                {placeholder}
              </option>
            )}
            {this.renderOptions(options)}
          </select>
          {selected && <span role="presentation">{selected}</span>}
        </StyledSelect>
        {touched[name] && errors[name] && (
          <Label basic pointing color="red">
            {errors[name]}
          </Label>
        )}
      </Form.Field>
    );
  }
}

SelectComponent.propTypes = {
  // added by formik field
  field: PropTypes.object,
  form: PropTypes.object,

  // manually add
  isStatic: PropTypes.bool,
  placeholder: PropTypes.string,
  placeholderDisabled: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool, // for default `Select xxx` empty option
  required: PropTypes.bool
};

SelectComponent.defaultProps = {
  field: { name: '', onBlur: () => {}, value: '' },
  form: { setFieldTouched: () => {}, errors: {}, touched: {}, values: {} }
};

const Select = ({ isStatic, ...rest }) =>
  isStatic ? (
    <SelectComponent {...rest} />
  ) : (
    <Field {...rest} component={SelectComponent} />
  );
export default Select;
